export enum OnboardingErrors {
  INVALID_CONSUMER = 'invalid_consumer',
  NOT_ONBOARDED = 'not_onboarded',
  WRONG_AMOUNTS = 'wrong_amounts',
  EXCEEDED_LIMIT = 'exceeded_limit',
  BANK_LOCKED = 'bank_locked',
  ALREADY_VERIFIED = 'already_verified',
  GENERIC = 'generic'
}

export interface OnboardingDetails {
  account_id: string;
  oauth_token: string | null;
  postal_code?: string;
  holder_name?: string;
}
